import { useState, forwardRef, useImperativeHandle, useRef, useEffect, useContext, useMemo } from 'react';
import PSAIModal from '@PSAIComponents/PSAIModal';
import styles from './index.module.scss';
import { MinusCircleFilled, PlusCircleFilled } from '@ant-design/icons'
import QRCode from 'qrcode.react'
import { Spin, message, Select, Popover } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons'
import Utils from '@utils/utils'
import { AppContext } from '@utils/AppContext';
import API from '@api/api'
import eventBus from "@utils/eventBus";
import InputNumber from '@view/page_v3/BatchProductImages/ConfigPage/components/InputNumber.jsx'

const AlipayQrcode = (props) => {
    const alipayFrameRef = useRef()

    useEffect(() => {
        alipayFrameRef.current.contentWindow.document.write(props.url)
    }, [props.url])

    return (
        <div className={styles.PayContent} key={props.url}>
            <div className={styles.iframePlaceholderWrap}>
                <Spin wrapperClassName={styles.iframePlaceholderSpin} spinning>
                    <div className={`${styles.iframePlaceholder} ${styles.alipay}`}></div>
                </Spin>
            </div>
            <iframe ref={alipayFrameRef}
                className={styles.payFrame}
                style={{ display: 'block' }}
                // srcDoc={payUrl}
                width="200"
                height="200"
                marginWidth={0}
                marginHeight={0}
                frameBorder="0"
                border="0"
                scrolling="no"
            ></iframe>
        </div>
    )
}

const WechatQrcode = (props) => {
    // weixin://wxpay/bizpayurl?pr=aYnckdQz3
    return (
        <div className={styles.PayContent} key={props.url}>
            <QRCode
                id="qrcode"
                value={props.url}
                size={200}
                level="H"
                style={{ margin: 'auto' }}
                imageSettings={{
                    src: require('@assets/images/icon_wxpay@2x.png'),
                    width: 50,
                    height: 50,
                    excavate: true,
                }}
            />
        </div>
    )
}


const DataSeatModal = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        open(callback) {
            callbackRef.current = callback
            setOpen(true)
        },
        close: () => setOpen(false),
    }));
    const callbackRef = useRef(null)
    const [open, setOpen] = useState(false);
    const isMounted = useRef(true)
    const [channel, setChannel] = useState('alipay') // 支付渠道 alipay or wechat
    const [payUrl, setPayUrl] = useState() // 支付链接
    const [dealAmount, setDealAmount] = useState()
    const [tradeId, setTradeId] = useState()
    const [salesListPlanData, setSalesListPlanData] = useState([])


    useEffect(() => {
        return () => isMounted.current = false
    }, [])

    const QRcoreContent = () => {
        return (
            <img className={styles.qrcodeSales} src={Utils.qrcodeSales} alt="扫码联系我们" />
        )
    }

    // 未添加套餐
    const hasNumItems = useMemo(() => {
        return salesListPlanData.some(item => item.num > 0);
    }, [salesListPlanData])


    const salesPurchase = () => {
        if (!hasNumItems) return;
        API.salesPurchase({
            skuList: salesListPlanData.filter(item => item.num > 0).map(item => ({
                skuId: item.id,
                num: item.num,
            })),
            channel: channel,
        }).then(res => {
            if (res?.code != 0) throw new Error(res.message)
            setPayUrl(res.data?.payUrl)
            setTradeId(res.data?.tradeId)
            setDealAmount(Number(res.data?.dealAmount))
        }).catch(err => {
            message.error(err.message)
        })
    }


    const checkTradeStatus = (timerRef) => {
        API.salesPaymentOrderStatus({ tradeId }).then(res => {
            if (res.code != 0) return
            const item = res.data
            if (item.status === 'success') {
                message.success('支付成功')
                callbackRef.current()
                eventBus.emit('updatePower')
                eventBus.emit('updateUserInfo')
                eventBus.emit('getUserOrgInfo')
                setOpen(false)
                setSalesListPlanData([])
                setPayUrl('')
                setTradeId('')
                setDealAmount(0)
                return
            } else if (item.status === 'closed') {
                message.success('订单已关闭')
                setSalesListPlanData([])
                setPayUrl('')
                setTradeId('')
                setDealAmount(0)
                setOpen(false)
                return
            } else {
                // 设置新的定时器
                timerRef.current = setTimeout(() => {
                    if (isMounted.current) checkTradeStatus(timerRef)
                }, 600)
            }
        })
    }

    useEffect(() => {
        if (!tradeId) return
        const timerRef = { current: null }
        checkTradeStatus(timerRef)

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current)
                timerRef.current = null
            }
        }
    }, [tradeId])


    useEffect(() => {
        if (!open || !salesListPlanData.length) return
        salesPurchase()
    }, [open, salesListPlanData, channel])


    useEffect(() => {
        if (!open) return
        salesListPlan()
    }, [open])

    const salesListPlan = () => {
        API.salesListPlan({
        }).then((res) => {
            if (res.code == 0) {
                setSalesListPlanData(res.data.map(item => ({
                    ...item,
                    num: 0,
                })) || [])
            } else message.error(res.message)
        })
    }

    const handleNumberChange = (type, item, value) => {
        if (type === 'minus' && item.num <= 0) return;
        if (type === 'add' && item.num >= 100) return;

        let newNum;
        switch (type) {
            case 'minus':
                newNum = item.num - 1;
                break;
            case 'add':
                newNum = item.num + 1;
                break;
            case 'change':
                newNum = value;
                break;
            default:
                return;
        }

        setSalesListPlanData(prevData =>
            prevData.map(dataItem => {
                if (dataItem.id === item.id) {
                    return {
                        ...dataItem,
                        num: newNum
                    };
                }
                return dataItem;
            })
        );

        // 检查是否所有商品数量都为0，如果是则清空payUrl
        const updatedData = salesListPlanData.map(dataItem => {
            if (dataItem.id === item.id) {
                return {
                    ...dataItem,
                    num: newNum
                };
            }
            return dataItem;
        });

        const allZero = updatedData.every(dataItem =>
            dataItem.id === item.id ? newNum === 0 : dataItem.num === 0
        );

        if (allZero) {
            callbackRef.current()
            setPayUrl('')
            setTradeId('')
            setDealAmount(0)
            setChannel('alipay')
        }
    }



    return <>
        <PSAIModal
            title={null}
            maxWidth={892}
            footer={null}
            open={open}
            maskClosable={false}
            okButtonProps={{ disabled: false, loading: false }}
            onCancel={() => {
                callbackRef.current()
                setSalesListPlanData([])
                setPayUrl('')
                setTradeId('')
                setDealAmount(0)
                setChannel('alipay')
                setOpen(false)
            }}
            onOk={() => setOpen(false)}
            zIndex={1002}
        >
            <div className={styles.DataPackageModal}>
                <div className={styles.DataPackageModalLeft}>
                    <p>购买套餐</p>
                    <div className={styles.DataPackageModalLeftMiddle}>
                        {
                            salesListPlanData?.map((item) => {
                                return <div key={item.id} className={styles.packageItem}>
                                    <span>{item.name}</span>
                                    <span>￥{item.discountPrice}</span>
                                    <span style={{ textDecoration: 'line-through' }}>{item.price}</span>
                                    <div style={{ marginLeft: 'auto' }}>
                                        <InputNumber
                                            currentNum={item.num}
                                            min={0} max={100}
                                            minusChange={() => handleNumberChange('minus', item)}
                                            addChange={() => handleNumberChange('add', item)}
                                            onChange={(value) => handleNumberChange('change', item, value)} />
                                    </div>
                                    <span>套</span>
                                </div>
                            })
                        }

                    </div>
                </div>
                <div className={styles.DataPackageModalRight}>
                    <p className={styles.Head2}>请扫码支付 <span>{dealAmount}</span> 元</p>
                    <Spin spinning={false}>
                        <div className={styles.Content}>
                            <div className={styles.Qrcode}>
                                {
                                    payUrl ?
                                        <>
                                            {channel == 'alipay' && <AlipayQrcode key={payUrl} url={payUrl} />}
                                            {channel == 'wechat' && <WechatQrcode key={payUrl} url={payUrl} />}
                                        </> : <img src={'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/batchProduceImages/AlipayQrcodeMask.png'} />
                                }
                            </div>
                            <div className={styles.ChannelBtn}>
                                <div
                                    className={channel == 'alipay' ? styles.Active : ''}
                                    onClick={() => { setPayUrl(''); setChannel('alipay') }}>
                                    <img src={require('@assets/images/icon_alipay.png')} />支付宝</div>
                                <div
                                    className={channel == 'wechat' ? styles.Active : ''}
                                    onClick={() => { setPayUrl(''); setChannel('wechat') }}>
                                    <img src={require('@assets/images/icon_wxpay.png')} />微信</div>
                            </div>
                            <div className={styles.bottomQrcode}>
                                <Popover placement="bottom" content={QRcoreContent}>
                                    添加客服可开发票 <InfoCircleOutlined className={styles.infoIcon} />
                                </Popover>
                            </div>
                        </div>
                    </Spin>
                </div>
            </div>
        </PSAIModal>
    </>
})
export default DataSeatModal
